import { useDateUtils } from '@melio/platform-utils';
import { useMemo } from 'react';

import { PaymentFlowFormFields } from '../types';

export const usePaymentFlowDefaultValues = (defaultValues: Partial<PaymentFlowFormFields>): PaymentFlowFormFields => {
  const { createDate } = useDateUtils();
  const now = useMemo(() => createDate(), [createDate]);

  return {
    vendorId: undefined,
    deliveryMethodId: undefined,
    amountToPay: undefined,
    deliveryDate: undefined,
    scheduleDate: now,
    fundingSourceId: undefined,
    deliveryPreference: undefined,
    noteToVendor: undefined,
    lastAmount: undefined,
    paymentPurpose: undefined,
    description: undefined,
    invoice: undefined,
    recurrenceType: defaultValues.recurrenceType || 'one_time',
    ...defaultValues,
  };
};
